import { WRONG_FACT_ROLES } from "./brandReports";

/** Field errors for a wrong-fact report (empty when it is complete). */
export function validateWrongFactReport(report) {
  const errors = {};
  if (!report.brandName?.trim()) errors.brandName = "Tell us which brand this is about.";
  if (!report.area) errors.area = "Pick the kind of fact that is wrong.";
  if ((report.issue || "").trim().length < 5) errors.issue = "Tell us what it says now.";
  if ((report.correct || "").trim().length < 3) errors.correct = "Tell us what the correct information is.";
  if (report.email?.trim() && !/^\S+@\S+\.\S+$/.test(report.email.trim()))
    errors.email = "That email address does not look right.";
  return errors;
}

/** The payload sent to the same correction queue the brand-page form uses (submitBrandCorrection). */
export function buildWrongFactReport(report) {
  const role = WRONG_FACT_ROLES.find((item) => item.id === report.role)?.label || "Not stated";
  const message = [
    `Fact that is wrong: ${report.area}`,
    `What it says now: ${report.issue.trim()}`,
    `What is correct: ${report.correct.trim()}`,
    `Proof or where to check: ${report.proof?.trim() || "Not given"}`,
    `Reported by: ${role}`,
  ].join("\n");
  return {
    brandName: report.brandName.trim(),
    message,
    area: report.area,
    issue: report.issue.trim(),
    correct: report.correct.trim(),
    proof: report.proof?.trim() || "",
    reporterRole: report.role || "",
    email: report.email?.trim() || undefined,
    source: "why-trust-us-report",
  };
}
